import React from 'react';
import type { ClassNameProp } from '../common-types';

/**
 * Props for a {@link NameCircle} component.
 */
export interface NameCircleProps extends ClassNameProp {
  /**
   * Person firstName.
   */
  firstName?: string;
  /**
   * Person lastName.
   */
  lastName?: string;
}

/**
 * Component for displaying the initials of a person's name in a colored circle.
 *
 * @param properties a {@link NameCircleProps} object
 * @return the created {@link JSX.Element}.
 * @constructor
 */
export function NameCircle({
  firstName = '',
  lastName = '',
  className = '',
  ...props
}: Readonly<NameCircleProps>): JSX.Element {
  const nameLetters =
    firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  const colorLetter = nameLetters.charAt(0);

  return (
    <div
      {...props}
      className={`ehs-name-circle nameCircleColor${colorLetter} ${className}`.trim()}
      aria-hidden
    >
      {nameLetters}
    </div>
  );
}
